import React from "react";
import { Star } from "lucide-react";
import { useApp } from "@/state/AppContext";

export function StarRating({ value = 0, size = 14, count, onChange, testId }) {
  const { t } = useApp();
  const stars = [1, 2, 3, 4, 5];
  return (
    <div
      className="flex items-center gap-1"
      data-testid={testId}
      role={onChange ? "group" : "img"}
      aria-label={onChange ? undefined : t("common.ratedOutOf", { value: Number(value).toFixed(1) })}
    >
      {stars.map((s) => {
        const filled = s <= Math.round(value);
        const Icon = (
          <Star
            size={size}
            className={filled ? "fill-[hsl(var(--accent))] text-[hsl(var(--accent))]" : "text-muted-foreground/40"}
          />
        );
        return onChange ? (
          <button
            key={s}
            type="button"
            onClick={() => onChange(s)}
            className="flex min-h-11 min-w-11 items-center justify-center transition-transform hover:scale-110 active:scale-95"
            data-testid={`${testId}-star-${s}`}
            aria-label={t("common.starLabel", { count: s })}
          >
            {Icon}
          </button>
        ) : (
          <span key={s} aria-hidden="true">
            {Icon}
          </span>
        );
      })}
      {count !== undefined &&
        (count > 0 ? (
          <span className="ml-1 text-xs text-muted-foreground">
            {Number(value).toFixed(1)} ({count})
          </span>
        ) : (
          <span className="ml-1 text-xs text-muted-foreground">{t("common.noReviewsYet")}</span>
        ))}
    </div>
  );
}
